export default "__VITE_ASSET__a7b6e8b6__"